import Text from "../../../../components/ui/Text";
import Button from "../ui/Button";
import { PlayerType } from "./Players";
import trashSound from "../../../../assets/audio/trash.wav";
import { useAudioEffects } from "../../../../hooks/use-audio-effects";

interface Props {
  className?: string;
  player: PlayerType;
  title?: string;
  onDeletePlayer: (player: PlayerType) => void;
  onClose: () => void;
}

const DeletePlayerModal = ({
  className = "",
  player,
  title = "Delete player",
  onClose,
  onDeletePlayer,
}: Props) => {
  const { playEffect } = useAudioEffects();
  return (
    <div
      className={`bg-gradient-to-b from-[#f12800] to-[#161820] p-5 w-full h-full rounded-md ${className}`}
    >
      <Text
        size="sm"
        className="!font-semibold text-white text-center leading-[105%]"
      >
        {title}
      </Text>
      <Text size="xxs" className="text-center text-white/70 leading-4 mt-8">
        Are you sure you want to delete{" "}
        <span className="text-yellow-500 font-semibold text-[14px]">
          {player?.name}
        </span>{" "}
        player ?
      </Text>

      <div className="grid grid-cols-2 gap-5 mt-8">
        <Button variant="gray" onClick={onClose}>
          <Text size="xxs" className="text-white">
            No
          </Text>
        </Button>
        <Button
          disableAudioEffect
          variant="blue"
          onClick={() => {
            onDeletePlayer(player);
            playEffect(trashSound);
          }}
        >
          <Text size="xxs" className="text-white">
            Yes
          </Text>
        </Button>
      </div>
    </div>
  );
};

export default DeletePlayerModal;
